<div
  class="munily-area-card"
  role="button"
  tabindex="0"
  (click)="onSelect()"
  (keydown.enter)="onSelect()"
  (keydown.space)="$event.preventDefault(); onSelect()"
>
  <div
    class="munily-area-card__pic"
    [class.munily-area-card__pic--icon]="type === 'icon'"
    [class.munily-area-card__pic--picture]="type === 'picture'"
    aria-hidden="true"
  >
    <img
      *ngIf="data?.imageUrl"
      class="munily-area-card__image"
      [class.munily-area-card__image--contain]="(data?.imageFit || 'contain') === 'contain'"
      [src]="data.imageUrl"
      alt=""
    />

    <div
      *ngIf="showMenuButton"
      class="munily-area-card__menu"
      [class.munily-area-card__menu--picture]="type === 'picture'"
      (click)="$event.stopPropagation()"
    >
      <common-icon-button
        [icon]="menuIcon"
        ariaLabel="Más opciones"
        color="weak"
        size="small"
        backgroundOpacity="0.25"
        [iconSet]="menuIconSet"
        (output)="onMenuClick()"
      ></common-icon-button>
    </div>
  </div>

  <div class="munily-area-card__body">
    <div class="munily-area-card__header">
      <h3 class="munily-area-card__title">{{ data?.title }}</h3>

      <div *ngIf="showRating" class="munily-area-card__rating">
        <mat-icon class="munily-area-card__rating-star material-symbols-rounded" aria-hidden="true">star</mat-icon>
        <span class="munily-area-card__rating-text">{{ data?.rating }}</span>
      </div>
    </div>

    <p class="munily-area-card__description">{{ data?.description }}</p>

    <div class="munily-area-card__footer">
      <div class="munily-area-card__capacity">
        <span class="munily-area-card__capacity-label">{{ capacityLabel }}</span>
        <span class="munily-area-card__capacity-number">{{ data?.capacity }}</span>
      </div>

      <app-info-chip
        *ngIf="data?.chip"
        [label]="data.chip.label"
        [color]="data.chip.color || 'blue'"
        [type]="data.chip.infoChipType || 'filled'"
        [size]="chipSizeResolved(data.chip.size)"
        [shape]="data.chip.shape || 'rounded-large'"
        [iconLeading]="data.chip.iconLeading"
        [iconTrailing]="data.chip.iconTrailing"
        [iconSet]="data.chip.iconSet || 'material-symbols-rounded'"
        [removable]="data.chip.removable || false"
      ></app-info-chip>
    </div>
  </div>
</div>

